var _defs, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: url(#linear-gradient);\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 0.52,
    y1: 12,
    x2: 23.48,
    y2: 12,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#302c8b"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#05a0ac"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M.99,23.83c.28,.01,.51-.2,.52-.48,.27-5.56,4.84-9.93,10.42-9.96,.02,0,.04,0,.06,0s.04,0,.06,0c5.58,.03,10.15,4.39,10.42,9.96,.01,.27,.23,.48,.5,.48,0,0,.02,0,.02,0,.28-.01,.49-.25,.48-.52-.25-5.14-3.86-9.34-8.65-10.55,2.23-1.06,3.79-3.34,3.79-5.97C18.61,3.14,15.65,.17,12,.17S5.39,3.14,5.39,6.79c0,2.63,1.55,4.91,3.79,5.97C4.38,13.96,.77,18.16,.52,23.3c-.01,.28,.2,.51,.48,.52ZM6.39,6.79c0-3.1,2.52-5.61,5.61-5.61s5.61,2.52,5.61,5.61-2.49,5.58-5.55,5.61c-.02,0-.04,0-.06,0s-.04,0-.06,0c-3.07-.03-5.55-2.54-5.55-5.61Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAccount);
export default __webpack_public_path__ + "static/media/account.5b75e1c0a6a643da8ea8092681e819d5.svg";
export { ForwardRef as ReactComponent };